$(document).on('turbo:load', () => {

});